import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsComponent } from './documents.component';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsModule } from '../../components/components.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { ngfModule } from "angular-file";
import { NgCircleProgressModule } from "ng-circle-progress";

const secondaryRoutes: Routes = [
  {
    path: '**',
    component: DocumentsComponent
  }
];

@NgModule({
  declarations: [DocumentsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(secondaryRoutes),
    ComponentsModule,
    NgbModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    ngfModule,
    NgCircleProgressModule.forRoot({
      radius: 10,
      outerStrokeWidth: 5,
      innerStrokeWidth: 5,
      showZeroOuterStroke: false,
      space: -5,
      animation: false,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      showTitle: false,
      showSubtitle: false,
      showUnits: false,
      showImage: true,
      imageHeight: 15,
      imageWidth: 15,
    }),
    FormsModule
  ]
})
export class DocumentsModule {
}
